import { render, staticRenderFns } from "./ViewAIReport.vue?vue&type=template&id=70c4b218&scoped=true&"
import script from "./ViewAIReport.vue?vue&type=script&lang=js&"
export * from "./ViewAIReport.vue?vue&type=script&lang=js&"
import style0 from "./ViewAIReport.vue?vue&type=style&index=0&id=70c4b218&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c4b218",
  null
  
)

export default component.exports